import {Box, Grid, Typography} from "@mui/material";

export default function SuccessPage() {
    return (
        <Box sx={{width:'90vw'}}>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center">

                <Grid item xs={4} >
                    <img src='/assets/images/success.svg' width="500"/>
                </Grid>

                <Grid item xs={3} >

                    <Typography variant='h3'>
                        Successfully submitted your response!
                    </Typography>

                </Grid>

            </Grid>
        </Box>
    );
}